function videoFit() {
    const videos = document.querySelectorAll('[data-video-fit]');
    
    const resizeVideos = () => {
        videos.forEach(target => {
            const video = target;
            const videoFrame = video.querySelector('iframe');
            const w = video.offsetWidth;
            const h = video.offsetHeight;
            const ratio = w / h;
            const fW = parseFloat(videoFrame.getAttribute("width"));
            const fH = parseFloat(videoFrame.getAttribute("height"));
            const fRatio = fW / fH;

            if (w === 0) return;

            if (fRatio > ratio) {
                videoFrame.style.width = `${h * fRatio}px`;
                videoFrame.style.height = `${h}px`;
                videoFrame.style.transform = `translateX(${-(h * fRatio - w) / 2}px)`;
            } else {
                videoFrame.style.width = `${w}px`;
                videoFrame.style.height = `${w / fRatio}px`;
                videoFrame.style.transform = `translateY(${-(w / fRatio - h) / 2}px)`;
            }
        });
    }

    resizeVideos();
    window.addEventListener('resize', resizeVideos);
}

videoFit();

export default videoFit;